import config from '../assets/app-env-config.json';

export const environment: any={

  _version:'0.0.2',
       //_apiUrl: 'http://192.168.2.26:4204/api/v1.0/',   //Dev
      
      //  _apiUrl: 'http://192.168.2.26:4204/api/v1.0/',   //Dev
    //    _apiUrl: 'https://fcapi.uneecopscloud.com/api/v1.0/',   //Dev
     // _apiUrl : 'http://192.168.2.26:4210/api/v1.0/',   //Stage
    //  _ssoApiUrl: 'http://192.168.2.26:4205/api/v1.0/',    //Dev

  
  
    _tokenApiUrl :'http://localhost:53493/api/ControllerJWTTokenGenerator',
    _tokenUser  :"mario",
    _tokenPwd  :"secret",
    _tokenPrefix :"Bearer ",
    _routeEForms :"",
    _routeLVForms :"",
//      _gateWayAPIUrl: '/proxy?url=https://slfp2311.uneecopscloud.com:60000/'


//*****************************************Stage Login************************************************* */
//  _apiUrl : 'https://192.168.2.79:60730/api/v1.0/',
//  _gateWayAPIUrl: 'https://analytics20.ubshanacloud.in:60000/'


    //*****************************************SSO Login********************************************** */

    //   _apiUrl: 'https://erp.ubshanacloud.in/erpapi/api/v1.0/' , 
    //  _gateWayAPIUrl: 'https://ubsdemo.ubshanacloud.in:60000/',



   //********************Start********************Prompt Login Live************************************ */

  // _apiUrl : 'https://sap.promptsteel.com/B1OnlineAPI/api/v1.0/',
  //   _gateWayAPIUrl:'https://sap.promptsteel.com:60000/'


//********************End********************Prompt Login Live************************************ */




 //********************Start********************Prompt Login Local Development************************************ */
 //_apiUrl : 'https://fs.insightone.in:4405/B1OnlineAPI/api/v1.0/',


//  _apiUrl : 'http://192.168.1.7:85/B1OnlineAPI/api/v1.0/',
//  _apiUrl : 'https://192.168.2.143:51957/api/v1.0/',
 // _gateWayAPIUrl: 'https://192.168.2.126:60000/'



  _apiUrl:config._apiUrl,
  _gateWayAPIUrl:config._gateWayAPIUrl

  //********************End********************Prompt Login Local Development************************************ */

  

}